export const dateString = (value: string) => {
  const date = new Date(value);
  const month = date.toLocaleDateString('en-US', { month: 'short' });

  return `${date.getDate()} ${month} ${date.getFullYear()}`;
};

export const dateTimeString = (
  value: string,
  format: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit' }
) => {
  const ds = dateString(value);
  const date = new Date(value);
  const time = date.toLocaleTimeString('en-US', format);

  return `${ds} at ${time}`;
};

const MAX_WORD_BOUNDARY_LENGTH = 40;
export const truncateAtWordBoundary = (
  text: string,
  maxLength: number = MAX_WORD_BOUNDARY_LENGTH
) => {
  if (text.length <= maxLength) {
    return text;
  }

  const truncated = text.slice(0, maxLength);
  const lastSpaceIndex = truncated.lastIndexOf(' ');
  const boundary = lastSpaceIndex > 0 ? lastSpaceIndex : maxLength;

  return `${truncated.slice(0, boundary)}...`;
};
